const BrowserPrint = window.BrowserPrint;

function getDefaultDevice() {
  return new Promise((resolve, reject) => {
    BrowserPrint.getDefaultDevice(
      'printer',
      (device) => resolve(device),
      (error) => reject(new Error('BrowserPrint not connected')),
    );
  });
}

function getLocalDevices() {
  return new Promise((resolve, reject) => {
    BrowserPrint.getLocalDevices(
      (device_list) => resolve(device_list),
      (error) => reject(new Error('BrowserPrint not connected')),
      'printer',
    );
  });
}

export async function connect() {
  const defaultDevice = await getDefaultDevice();
  const devices = await getLocalDevices();
  if (!defaultDevice.uid) {
    throw new Error('Default device not found');
  } else if (devices.length) {
    const device = devices.find((device) => device?.uid === defaultDevice?.uid);
    if (device && device.uid) {
      return device;
    }
  }
  throw new Error('Device not found');
}

export async function checkPrinter(printerDevice) {
  const devices = await getLocalDevices();
  if (devices.length) {
    const currentDevice = devices.find(
      (device) => device?.uid === printerDevice?.uid,
    );
    if (currentDevice && currentDevice.uid) {
      return true;
    }
  }

  return false;
}

export function print(device, label, maxRetry = 5) {
  return new Promise((resolve, reject) => {
    let retry = 0;
    const success = () => resolve();
    const failure = () => {
      if (++retry <= maxRetry) {
        device.send(label, success, failure);
      } else {
        reject();
      }
    };
    device.send(label, success, failure);
  });
}
